import { CalendarBlank } from '@phosphor-icons/react';

export default CalendarBlank;
